import * as React from 'react';
import '../../../panels/panels.css';
import { Button, Label, Segment, Form, Radio, Input } from 'semantic-ui-react';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import Toast from '../../../sys/toast';
import OAuth, { OAuthClientStatus } from '../../../api';

export default function AWSConfig() {
    const [awsOption, setAWSOption] = React.useState('');
    const [awsSecretKey, setAWSSecretKey] = React.useState('');
    const [awsAccessKeyId, setAWSAccessKeyId] = React.useState('');
    const [awsRegion, setAWSRegion] = React.useState('');

    const fetchData = () => {
        let url = 'http://default/api/config/section/options/aws';
        axios.post(url, {
            mode: 'get',
            defaults: {
            },
            options: [
                'awsOption', 'awsSecretKey', 'awsAccessKeyId', 'awsRegion'
            ]
        })
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.section !== undefined) {
                    let responseObject = response.data.section.options;
                    setAWSOption(responseObject[0].value);
                    setAWSSecretKey(responseObject[1].value);
                    setAWSAccessKeyId(responseObject[2].value);
                    setAWSRegion(responseObject[3].value);
                } else{
                    console.log('expected array of config values, got ', response.data);
                }            
            })
            .catch(function (error: AxiosRequestConfig) {
                console.log('fetchData() error: ', error);
            });
    }

    const updateConfig = (e: any, data: any) => {
        let url = 'http://default/api/config/section/options/aws';
        let options = [
            { 'name': 'awsSecretKey', 'value': awsSecretKey },
            { 'name': 'awsAccessKeyId', 'value': awsAccessKeyId },
            { 'name': 'awsRegion', 'value': awsRegion },
            { 'name': 'awsOption', 'value': awsOption }
        ];

        axios.post(url, {
            mode: 'modify',
            defaults: {
            },
            options: options
        })
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.code === 'SUCCESS') {
                    Toast.info('AWS configuration applied');
                    fetchData();
                } else {
                    Toast.error('Failed to update AWS Diagnostics configuration');
                    Toast.error('Error: ' + response.data.det);
                }
            })
            .catch(function (error: AxiosRequestConfig) {
                console.log('updateConfig() error: ', error);
                Toast.error('Failed to update AWS Diagnostics configuration');
            });
    }

    React.useEffect(() => {
        fetchData();
    }, []);

    return (
        <OAuth.Context>
            {(oauth: OAuthClientStatus) => {
                return (
                    <React.Fragment>
                        <div className="assetAliasFilters">
                            <Label className="system-config-pageHeader">
                                AWS Configurations
                            </Label>
                            <Button
                                floated="right"
                                className="rightButton"
                                content="Apply"
                                title="Update Config"
                                onClick={(e, data) => updateConfig(e, data)}
                            />
                        </div>

                        <div className="vertical-flex-main">
                            <Segment.Group className="system-config-segment">
                                <Segment className="segment-header">AWS S3 Authorization</Segment>
                                <Segment>
                                    <Form>
                                        <Form.Group grouped>
                                            <Label className="right-align-label">
                                                Disabled
                                            </Label>
                                            <Radio
                                                name="radioGroup"
                                                value="disable"
                                                checked={awsOption === 'disable'}
                                                onChange={(e: any, data: any) => setAWSOption(data.value)}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label">
                                                Web Identity Token
                                            </Label>
                                            <Radio
                                                name="radioGroup"
                                                value="webIdentityToken"
                                                checked={awsOption === 'webIdentityToken'}
                                                onChange={(e: any, data: any) => setAWSOption(data.value)}
                                            />
                                        </Form.Group>

                                        <Form.Group grouped>
                                            <Label className="right-align-label">
                                                AWS Credentials
                                            </Label>
                                            <Radio
                                                name="radioGroup"
                                                value="awsCredentials"
                                                checked={awsOption === 'awsCredentials'}
                                                onChange={(e: any, data: any) => setAWSOption(data.value)}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label">
                                                Access Key ID
                                            </Label>
                                            <Input
                                                disabled={(awsOption !== "awsCredentials")}
                                                maxLength={200}
                                                className="ui-input input-width-450"
                                                value={awsAccessKeyId}
                                                onChange={(e: any, data: any) => setAWSAccessKeyId(data.value)}
                                            />
                                        </Form.Group>

                                        <Form.Group grouped>
                                            <Label className="right-align-label">
                                                Secret Key
                                            </Label>
                                            <Input
                                                disabled={(awsOption !== "awsCredentials")}
                                                maxLength={200}
                                                type="password"
                                                className="ui-input input-width-450"
                                                value={awsSecretKey}
                                                onChange={(e: any, data: any) => setAWSSecretKey(data.value)}
                                            />
                                        </Form.Group>

                                        <Form.Group grouped>
                                            <Label className="right-align-label">
                                                AWS Region
                                            </Label>
                                            <Input
                                                disabled={(awsOption === "disable")}
                                                maxLength={200}
                                                className="ui-input input-width-450"
                                                value={awsRegion}
                                                onChange={(e: any, data: any) => setAWSRegion(data.value)}
                                            />
                                        </Form.Group>
                                    </Form>
                                </Segment>
                            </Segment.Group>
                        </div>

                    </React.Fragment>
                );
            }}
        </OAuth.Context>
    );
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/config/monitoring/awsConfig.tsx